import api from './api';

export const getAppreciations = async (skip = 0, limit = 100) => {
  const response = await api.get(`/appreciations/?skip=${skip}&limit=${limit}`);
  return response.data;
};

export const createAppreciation = async (appreciationData) => {
  const response = await api.post('/appreciations/', appreciationData);
  return response.data;
};

// New method to send to multiple recipients
export const createMultipleAppreciations = async (senderUsername, receiverUsernames, message) => {
  const promises = receiverUsernames.map(receiverUsername => {
    return createAppreciation({
      sender_username: senderUsername,
      receiver_username: receiverUsername,
      message: message
    });
  });
  
  return Promise.all(promises);
};

export const getSentAppreciations = async (username) => {
  const response = await api.get(`/appreciations/sent/${username}`);
  return response.data;
};

export const getReceivedAppreciations = async (username) => {
  const response = await api.get(`/appreciations/received/${username}`);
  return response.data;
};

export const getLeaderboard = async (department = null) => {
  const params = department ? `?department=${encodeURIComponent(department)}` : '';
  const response = await api.get(`/appreciations/leaderboard${params}`);
  return response.data;
};

export const getDepartmentStats = async () => {
  const response = await api.get('/appreciations/departments/stats');
  return response.data;
};

export const createSharedAppreciation = async (recipients, message, companyValues) => {
  const response = await api.post('/appreciations/shared', {
    recipients,
    message,
    company_values: companyValues
  });
  return response.data;
};

export const getSharedAppreciation = async (token) => {
  const response = await api.get(`/appreciations/shared/${token}`);
  return response.data;
};